import { toast } from "react-toastify";
import FiscalYear from "models/fiscal-year";

/** Visible fiscal years (hide = false), newest first. */
export const getVisibleFiscalYears = async (): Promise<FiscalYear[] | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/fiscal-years`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as FiscalYear[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting Fiscal Years");
        return null;
    }
}
